import { createSlice } from "@reduxjs/toolkit";
import { 
  getStudyFlow, 
  createStudyFlow, 
  updateStudyFlow, 
  deleteStudyFlow,
  clearLocalActiveStudyFlow 
} from "./actions";

export const initialState = {
  studyFlow: { 
    id: '', 
    send_at: '', 
    time_zone: '', 
    prompt: '',
    updated_at: '' 
  },
  loading: false
};

const slice = createSlice({
  name: 'studyFlows',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getStudyFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(getStudyFlow.fulfilled, (state, action) => {
        const { study_flow } = action.payload;
        const studyFlow = { ...state.studyFlow, ...study_flow };

        state.loading = false;
        state.studyFlow = studyFlow;
      })
      .addCase(getStudyFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(createStudyFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(createStudyFlow.fulfilled, (state, action) => {
        const { study_flow } = action.payload;

        state.loading = false;
        state.studyFlow = study_flow;       
      })
      .addCase(createStudyFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(updateStudyFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateStudyFlow.fulfilled, (state, action) => {
        const { status, study_flow } = action.payload;
        const updatedStudyFlow = { ...state.studyFlow, ...study_flow };

        state.loading = false;
        if (status === 204) state.studyFlow = updatedStudyFlow;       
      })
      .addCase(updateStudyFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deleteStudyFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteStudyFlow.fulfilled, (state, action) => {
        const { status } = action.payload;

        state.loading = false;
        if (status === 204) state.studyFlow = initialState.studyFlow;       
      })
      .addCase(deleteStudyFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(clearLocalActiveStudyFlow, state => {
        state.studyFlow = initialState.studyFlow;
      })
  }
})

export default slice.reducer;